import React, { useState, useEffect } from "react";
import "../style/floatingActions/floatingActions.css";
import { showToast } from "../utils/commonUtil";

const FloatingActions = ({
  whatsappNumber,
  whatsappEnabled,
  inquiryEnabled,
  inquiryAction,
  captchaSrc,
  status,
  submitting,
  submitSuccess,
  submitError,
  submitInquiry,
}) => {
  const [showInquiry, setShowInquiry] = useState(false);

  const toggleInquiry = () => {
    setShowInquiry(!showInquiry);
  };


  // Handle success/error messages
  // useEffect(() => {
  //   if (submitSuccess) {
  //     showToast.success("Your inquiry has been submitted successfully!");
  //   }
  //   if (submitError) {
  //     showToast.error("Failed to submit inquiry. Please try again.");
  //   }
  // }, [submitSuccess, submitError]);

  // Function to generate a random 4-digit captcha string
  const generateCaptcha = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };

  const [captcha, setCaptcha] = useState(generateCaptcha());
  useEffect(() => {
    setCaptcha(generateCaptcha());
  }, []);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const captchaInput = formData.get("captcha_input");
    if (captchaInput !== captcha) {
      showToast.error("Invalid captcha, please try again");
      setCaptcha(generateCaptcha());
      e.target.querySelector("input[name='captcha_input']").value = "";
      return;
    }
    const inquiryData = {
      description: formData.get("inqmessage"),
      mobile_number: formData.get("inqphone"),
      email: formData.get("inqemail"),
    };

    try {
      await submitInquiry(inquiryData);
      showToast.success("Your inquiry has been submitted successfully!");
      e.target.reset();
      setShowInquiry(false);
      setCaptcha(generateCaptcha());
    } catch (error) {
      showToast.error("Failed to submit inquiry. Please try again.");
      setCaptcha(generateCaptcha());
    }
  };

  return (
    <>
      {/* Floating Buttons */}
      <div className="b-notification-bar">
        <ul className="btnlist">
          {whatsappEnabled && (
            <li className="item whatsapp">
              <a
                href={`https://wa.me/${whatsappNumber}`}
                className="btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-whatsapp"></i>
              </a>
            </li>
          )}

          {inquiryEnabled && (
            <li className="item inquiry">
              <div
                className="btn"
                onClick={toggleInquiry}
                style={{ cursor: "pointer" }}
              >
                <i className="fa fa-envelope"></i>
              </div>
              {showInquiry && (
                <div className="info-box inq" style={{ display: "block" }}>
                  <div className="bold pb-2" style={{ paddingRight: "18px" }}>
                    Fill the details and we’ll get back to you soon
                  </div>
                  <button className="closeInquiry" onClick={toggleInquiry}>
                    <i className="fa fa-times"></i>
                  </button>
                  <form id="contactForm" onSubmit={handleSubmit}>
                    <div className="inquiry-box">
                      <div className="form-group-block">
                        <div className="form-group fullwidth">
                          <textarea
                            className="form-control"
                            placeholder="Tell us your requirements"
                            id="inqmessage"
                            name="inqmessage"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            className="form-control"
                            maxLength="10"
                            pattern="\d{10}"
                            placeholder="Phone"
                            type="text"
                            id="inqphone"
                            name="inqphone"
                            required
                          />
                        </div>
                        <div className="form-group">
                          <input
                            className="form-control"
                            maxLength="50"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                            placeholder="Email"
                            type="email"
                            id="inqemail"
                            name="inqemail"
                            required
                          />
                        </div>
                        <div className="form-group captcha-flex">
                          <div className="d-flex">
                            <div className="captcha-text me-2 bold bg-light p-2 rounded">
                              {captcha}
                            </div>
                            <input
                              className="captcha-input form-control"
                              maxLength="4"
                              placeholder="captcha"
                              pattern="\d{4}"
                              type="text"
                              name="captcha_input"
                              // required
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <button
                            type="submit"
                            className="btn-submit"
                            disabled={submitting}
                          >
                            {"Submit"}
                          </button>
                        </div>
                        <span id="lblInfo1"></span>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default FloatingActions;
